import { IMapOptions } from "@interfaces/maps/Map.interface";
import { DATE_RANGE_MODE } from "@ts/dtos";

export const MODE_TO_SECONDS: Record<DATE_RANGE_MODE, number | null> = {
  [DATE_RANGE_MODE.LAST_SECONDS]: null, // From user option
  [DATE_RANGE_MODE.LAST_HOUR]: 3600, // 1 hour
  //Dudo que se use apartir de aqui eliminaremos
  [DATE_RANGE_MODE.LAST_12_HS]: 43200, // 12 hour
  [DATE_RANGE_MODE.LAST_24_HS]: 86400, // 24 hour
  [DATE_RANGE_MODE.LAST_WEEK]: 604800, // 7 day
  [DATE_RANGE_MODE.LAST_MONTH]: 2592000, // 30 day 
  [DATE_RANGE_MODE.LAST_YEAR]: 31536000, // 365 day
  [DATE_RANGE_MODE.TODAY]: null, // Depende del inicio del día
  [DATE_RANGE_MODE.THIS_WEEK]: null, // Depende del inicio de la semana
  [DATE_RANGE_MODE.DATE_RANGE]: null, // Depende de las fechas proporcionadas
};

//#region Worker
export const getSecondsForMode = (mapOptions: IMapOptions): number => {
  const now = new Date();

  switch (mapOptions.mode) {
    case 'lastPosition':
      return 0;
    case DATE_RANGE_MODE.LAST_SECONDS:
      return mapOptions.lastSeconds ?? 0;
    case DATE_RANGE_MODE.TODAY:
      const startOfDay = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
      return Math.floor((now.getTime() - startOfDay) / 1000);


    case DATE_RANGE_MODE.THIS_WEEK:
      const startOfWeek = new Date(now);
      startOfWeek.setUTCDate(now.getUTCDate() - now.getUTCDay());
      startOfWeek.setUTCHours(0, 0, 0, 0); // Hora UTC
      return Math.floor((now.getTime() - startOfWeek.getTime()) / 1000);


    case DATE_RANGE_MODE.DATE_RANGE:
      return -1;

    default:
      return MODE_TO_SECONDS[mapOptions.mode] ?? -1;
  }
};
export const calculateThreshold = (mapOptions: IMapOptions): number => {
  const now = Date.now();
  const secondsMS = getSecondsForMode(mapOptions); // (0 = save the last reading position, -1 = nothing )
  return secondsMS > 0 ? now - secondsMS * 1000 : secondsMS;
};
export const processItems = (items: { id: string; readings: any[] }[], threshold: number) => {
  return items
    .map((item) => {
      let readingsToRemove;

      if (threshold === 0) {
        readingsToRemove =
          item.readings.length > 1
            ? item.readings.slice(1).map((reading) => reading.id)
            : [];
      } else if (threshold === -1) {
        readingsToRemove = [];
      } else {
        readingsToRemove = item.readings
          .filter((reading) => {
            const readingTimestamp = new Date(reading.timestamp).getTime();
            return readingTimestamp < threshold;
          })
          .map((reading) => reading.id);
      }

      return {
        itemID: item.id,
        readingsToRemove,
      };
    })
    .filter((item) => item.readingsToRemove.length > 0);
};
//#endregion


